import { StageMatchTab } from 'modules/championship/domain/enums/stage-match-tab';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { CalendarGame } from 'modules/schedule/domain/interfaces/calendar';

/**
 * Страница матча на вкладке «Результат» в этапах турнира.
 * Без этапа (`round`) страницы матча нет — тогда `undefined`, и кнопку не показывают.
 */
export function getMatchResultPath(game: CalendarGame): string | undefined {
  if (!game.round) {
    return undefined;
  }

  return Pages.CHAMPIONSHIPS.STEPS.builders.match(game.championship.id, game.round.stageId, game.id, StageMatchTab.RESULT);
}
